import { AsyncActionType } from '../../data/utils';

export const VALIDATE_OTP = new AsyncActionType('VALIDATE', 'OTP');
export const OTP_TIMER = new AsyncActionType('OTP', 'TIMER');
export const OTP_TIMER_DECREASE = 'OTP_TIMER_DECREASE';

// `identifier` is { token } when reached via the real emailed link, or { email }
// when reached via the in-app "Enter Code" button (PT 5.8, recommendation #1 -
// the initial forgot-password response no longer carries a token to use here).
export const validateOtp = (code, identifier) => ({
  type: VALIDATE_OTP.BASE,
  payload: {
    code,
    ...identifier,
  },
});

export const validateOtpBegin = () => ({
  type: VALIDATE_OTP.BEGIN,
});

export const validateOtpSuccess = (resetLink) => ({
  type: VALIDATE_OTP.SUCCESS,
  payload: {
    resetLink,
  },
});

export const validateOtpFailure = () => ({
  type: VALIDATE_OTP.FAILURE,
});

export const validateOtpReset = () => ({
  type: VALIDATE_OTP.RESET,
});

// `identifier` is { token } or { email }; see validateOtp() above.
export const otpTimer = (identifier) => ({
  type: OTP_TIMER.BASE,
  payload: {
    ...identifier,
  },
});

export const otpTimerBegin = () => ({
  type: OTP_TIMER.BEGIN,
});

export const otpTimerSuccess = (payload) => ({
  type: OTP_TIMER.SUCCESS,
  payload,
});

export const otpTimerFailure = (payload) => ({
  type: OTP_TIMER.FAILURE,
  payload,
});

export const otpTimerDecrease = () => ({
  type: OTP_TIMER_DECREASE,
});
